import React from 'react'
import ChooseImg from '../assets/why-choose.jpg';

const WhyChoose = () => {
  return (
    <>
      {/* why choose section */}
<section className='my-5'>
    <div className='container'>

<div className='row'>

<div className='col-lg-6 col-12 my-2'>
<img src={ChooseImg} className='choose-img img-fluid w-100' alt='Choose Us' />
</div>

<div className='col-lg-6 col-12 my-2'>
<p className='banner-subheading'><i class="fa-solid fa-laptop-code"></i> Why Choose Us</p>
                            <p className='sec-heading'>Trusted Partner For Project Success</p>

<p className='text-muted fw-semibold'>At Dectwin Services, we combine innovation, expertise, and customer-centric solutions to 
    deliver exceptional software and web development services in Prayagraj that drive success for your business.</p>

<div className='d-flex'>
<i class="fa-solid choose-icon my-2 me-3 fa-people-arrows"></i>
<div>
    <p className='fs-5 fw-bold my-0'>Customized Solutions</p>
    <p className='text-muted'>We provide personalized solutions that align with your business requirements, ensuring you receive the best technology to improve efficiency and grow your brand.</p>
</div>
</div>
{/* flex ends */}

<div className='d-flex'>
<i class="fa-solid choose-icon my-2 me-3 fa-ranking-star"></i>
<div>
    <p className='fs-5 fw-bold my-0'>Commitment to Quality</p>
    <p className='text-muted'>We prioritize that every project is completed with the highest quality standards, timely delivery, and continuous support for lasting success.</p>
</div>
</div>
{/* flex ends */}


</div>
{/* right section ends */}


</div>
{/* row ends */}

    </div>
</section>
{/* why choose section ends */}

    </>
  )
}

export default WhyChoose
